import { render, staticRenderFns } from "./GLAcctNoDet.vue?vue&type=template&id=8123b20c&"
import script from "./GLAcctNoDet.vue?vue&type=script&lang=js&"
export * from "./GLAcctNoDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports